import React from "react";

export default function PageHero({ overline, title, subtitle, image }) {
  return (
    <section className="relative bg-navy text-sand pt-36 pb-20 overflow-hidden" data-testid="page-hero">
      <div className="grain-overlay" />
      {image && (
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
      )}
      <div className="absolute inset-0 bg-navy/60" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        {overline && (
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-gold" />
            <span className="text-xs tracking-[0.3em] uppercase text-gold font-mono">{overline}</span>
          </div>
        )}
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight max-w-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-sand/70 max-w-2xl text-lg leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
